export default __webpack_public_path__ + "static/media/logo.25288a39.svg";